import clsx from 'clsx';
import React from 'react';
import styles from './SchemaExplorerShimmer.module.scss';

const folderShimmerDimensions = ['134px', '164px', '84px', '164px', '144px', '84px'];

export function SchemaExplorerShimmer({
  className = ''
}) {
  return (
    <div className={clsx(styles.sourceDetailsWrapper, className)}>
      <div className={styles.sourceDetailsContainer}>
        <div className='mr-2'>
          <div className='shimmer shimmer-circle' style={{ width: '40px', height: '40px' }} />
        </div>

        <div className={styles.sourceDetails}>
          <div className='shimmer shimmer-line' style={{ width: '64px', height: '12px' }} />
          <div className='shimmer shimmer-line mt-2' style={{ width: '87px', height: '8px' }} />
        </div>
      </div>

      <div className={styles.schemaSearchContainer}>
        <div className='shimmer shimmer-line' style={{ width: '124px', height: '12px' }} />
      </div>

      <div className={styles.listWrapper}>
        <div className='px-5 py-4'>
          <div className='shimmer shimmer-line' style={{ width: '94px', height: '12px' }} />
        </div>

        {folderShimmerDimensions.map((dimension, index) => (
          <div key={index} className='center-flex-row px-5 py-4'>
            <div
              className='shimmer shimmer-circle mr-1'
              style={{ width: '12px', height: '12px' }}
            />
            <div className='shimmer shimmer-line' style={{ width: dimension, height: '12px' }} />
          </div>
        ))}
      </div>
    </div>
  );
}
